import Color from '../Color.mjs'
import superMeta from '../_ARCH/metaArchNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.LIGHT_BLUE,
    alias: '入口模型',
    // 总图节点别名：按项目子类型覆盖（需求模型B）
    aliasBySubType: {RMB: '用户界面'},
    archName: '界面地图',
    archUrl: '/ProjectUiMap',
    detailUrl: '/UaDetail',
    detailIdProp: 'uaId',
    listUrl: 'UaList',
    mapProp: 'uaMap',
    moduleType: 'UM',
    name: '入口结构',
    type: 'UA',
}
